import { createFileRoute } from '@tanstack/react-router'
import { StatsPage } from '@/features/dashboard/StatsPage'

export const Route = createFileRoute('/_authenticated/stats')({
  component: StatsPage,
})
